"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var easing_1 = require("../helper/easing");
var calculateStep = core_1.memo(function (value, range, easing) {
    var steps = 1 / range.length;
    var index = 0;
    var val = value;
    if (easing) {
        val = typeof easing === 'string' ? easing_1.easeValue(value, easing) : easing(value);
    }
    for (var i = 1; i < range.length; i += 1) {
        if (val > steps * i)
            index = i;
    }
    return range[index];
});
exports.step = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return ranges[0];
    }
    return calculateStep(values, ranges, easing);
}; };
exports.useStep = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.step(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=step.js.map